/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import AddIcon from '@material-ui/icons/Add';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import { handleClick, initPushNotification } from './PushNotification.services';
import {
  TableFooter,
  Button,
  EmptyView,
  Table,
  BackButton,
  Paper,
} from '../../components';
import { styles } from './PushNotification.styles';
import { isObjectNotEmpty } from '../../utils/tools';
import { marketing } from '../../constants';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/notification.svg';
import { ReactComponent as ImportedNotifSVG } from '../../assets/pictures/pushNotif.svg';
import {
  EMPTY_DESIGN_PUSH_NOTIF_TEXT,
  EMPTY_DESIGN_PUSH_NOTIF_TITLE
} from '../../constants/dishopInfo';
import { NOTIF_TABLE_HEAD } from '../../constants/table';
import { getDateFormat } from '../../utils/suitableDate';
import apiService from '@dishopsaas/dishop-backend-api-service/api.service'
import { PushNotifModal } from './PushNotificationModal'

function PushNotification({ classes, history = {}, shopId, pushNotification, name, openErrorModal }) {

  const [stateObj, setStateObjRaw] = useState({
    modalOpen: false,
    title: '',
    message: '',
    isLoading: true,
    isLoadingModal: false,
    toAllUsers: false,
    clients: {},
    devices: {},
    pushNotification: [],
    allUsers: [],
    users: []
  });
  const setStateObj = myNewObj => setStateObjRaw({ ...stateObj, ...myNewObj });
  const data = stateObj.pushNotification && Object.values(stateObj.pushNotification).map(element => ({
    date: element.date,
    cible: element.cible === shopId ? name : 'Tous',
    title: element.title,
    message: element.message,
    nbUsers: element.nbUsers
  }))

  useEffect(() => {
    (async () => {
      const [clients, devices] = await Promise.all([ // TODO this HEAVY Api call exists in PushNotification AND Clients AND Support.View
        apiService.usersGetAll({ orderByChild: 'fcmToken', startAt: '' }),
        apiService.devicesGetAll({ filter: ['hasUser', false] })
      ]);
      setStateObj({ clients, devices, pushNotification, isLoading: false });
    })();
  }, []);

  useEffect(() => {
    initPushNotification(shopId, stateObj.clients, stateObj.devices, pushNotification, setStateObj);
  }, [shopId, pushNotification, stateObj.clients, stateObj.devices]);

  const createTableRow = data => <TableBody>
    {data.map((e, i) => <TableRow key={i}>
      <TableCell align="center" className={classes.produits}>
        {getDateFormat(e.date, 'lll')}
      </TableCell>
      <TableCell align="center" className={classes.produits}>
        {e.nbUsers}
      </TableCell>
      <TableCell align="center" className={classes.produits}>
        {e?.title || ''}
      </TableCell>
      <TableCell align="center" className={classes.produits}>
        {e.message}
      </TableCell>
      <TableCell align="center" className={classes.produits}>
        {e.cible}
      </TableCell>
    </TableRow>)}
  </TableBody>

  return (
    <div className="p-4 ">
      <BackButton
        className="p-0 pb-3"
        onClick={() => history.goBack()}
        title={marketing.pushNotification.text}
        subtitle={marketing.pushNotification.description}
      />

      {isObjectNotEmpty(stateObj.pushNotification) && !stateObj.isLoading ? (
        <>
          <div className='row col-12'>
            <Paper className='py-4 col-6'>
              <div className='row pb-3'>
                <EmptyView
                  className={classes.svg}
                  src={ImportedSVG}
                  title='Envoyez des notifications manuelles'
                  text={`Personnalisez l'envoi des notifications`}
                >
                  <ButtonNotif setStateObj={setStateObj} />
                </EmptyView>
              </div>
            </Paper>

            <Paper className={`py-4 col-6 ${classes.paperStyle}`}>
              <Button className={`btn-xs-block mx-3 col-xs-8 ${classes.buttonStyle}`} disabled>
                <div className="row justify-content-center align-items-center mr-0 ml-0">
                  <p className="m-0 ml-1"> Arrive bientôt</p>
                </div>
              </Button>

              <div className={`col-12 ${classes.emptyStyle}`} >
                <EmptyView
                  className={classes.disabledSvg}
                  src={ImportedNotifSVG}
                  title='Programmez des notifications automatiques'
                  text='Programmation automatique des notifications'
                >
                  <Button className={`btn-xs-block mx-3 ${classes.disabledButton}`} disabled>
                    <div className="row justify-content-center align-items-center mr-0 ml-0">

                      <p className="m-0 ml-1"> Disponible bientôt</p>
                    </div>
                  </Button>
                </EmptyView>
              </div>
            </Paper>
          </div>
          <h4 className='py-4'>Historique des envois</h4>
          <Paper scrollOption="auto">
            <Table
              headCells={NOTIF_TABLE_HEAD}
              classes={classes}
              bodyRows={data}
              createTableRow={createTableRow}
              order="desc"
              orderBy="date"
            />
          </Paper>
          <TableFooter
            rowsPerPageOptions={[5, 10, 25]}
            lengthOption={_.keys(pushNotification).length}
          />
        </>
      ) : (
        <EmptyView
          className={classes.svg}
          src={ImportedSVG}
          isLoading={stateObj.isLoading}
          title={EMPTY_DESIGN_PUSH_NOTIF_TITLE}
          text={EMPTY_DESIGN_PUSH_NOTIF_TEXT}
        >
          <ButtonNotif setStateObj={setStateObj} />
        </EmptyView>
      )}
      <PushNotifModal classes={classes} openErrorModal={openErrorModal} setStateObj={setStateObj} stateObj={stateObj} />
    </div>
  );
}


function ButtonNotif({ setStateObj }) {
  return <Button className="btn-xs-block mx-3" color="primary" onClick={() => handleClick(setStateObj)}>
    <div className="row justify-content-center align-items-center mr-0 ml-0">
      <AddIcon />
      <p className="m-0 ml-1"> Créer une nouvelle Push Notification</p>
    </div>
  </Button>
}

function mapStateToProps({ notifs, user, page, firebaseRealTime }) {
  const { shop = {} } = firebaseRealTime;
  const { pushNotification, name } = shop;
  const { pushNotifs } = notifs;
  const { shopId, clients, shopName, nbShops } = user;
  return {
    pushNotification,
    pushNotifs,
    shop,
    nbShops,
    page,
    clients,
    shopId,
    shopName,
    name
  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(PushNotification)));
